import { rtkApi } from '@/shared/api/rtkApi/rtkApi';
import { LocalStorageService } from '@/shared/services/localStorage.service';
import { getStore } from '@/shared/lib/store/storeInstance';
import { adminActions } from '../..';

export const resetApiCaches = () => {
  const store = getStore();
  if (store) {
    store.dispatch(rtkApi.util.resetApiState());
  }
};

export const clearAuthAndRedirect = (redirectPath: string = '/login') => {
  LocalStorageService.clearAllTokens();
  resetApiCaches();

  if (typeof window !== 'undefined') {
    localStorage.removeItem('isAuth');
    localStorage.removeItem('userId');
    localStorage.removeItem('documentId');
    localStorage.removeItem('username');
    localStorage.removeItem('email');
    localStorage.removeItem('user');

    const store = getStore();
    if (store) {
      store.dispatch(adminActions.setIsAuth(false));
    }

    if (window.location.pathname !== redirectPath) {
      window.location.href = redirectPath;
    }
  }
};
